import React from 'react';
import { CreditCard } from 'lucide-react';

const PROVIDERS = {
  venmo: { label: 'Venmo', color: '#008CFF', letter: 'V', bg: '#008CFF' },
  cashapp: { label: 'Cash App', color: '#00D632', letter: '$', bg: '#00D632' },
  paypal: { label: 'PayPal', color: '#003087', letter: 'P', bg: '#003087' },
  zelle: { label: 'Zelle', color: '#6D1ED4', letter: 'Z', bg: '#6D1ED4' },
};

export function getProviderFromMethod(method) {
  if (!method) return null;
  const m = method.toLowerCase().replace(/\s+/g, '');
  if (m.includes('venmo')) return 'venmo';
  if (m.includes('cashapp') || m.includes('cash app') || m === 'cash') return 'cashapp';
  if (m.includes('paypal')) return 'paypal';
  if (m.includes('zelle')) return 'zelle';
  return null;
}

export function getProviderConfig(provider) {
  return PROVIDERS[provider] || null;
}

export function PaymentProviderLogo({ provider, method, size = 'md' }) {
  const resolved = provider || getProviderFromMethod(method);
  const config = PROVIDERS[resolved];

  const sizeMap = { sm: 'w-6 h-6 text-[10px]', md: 'w-8 h-8 text-xs', lg: 'w-10 h-10 text-sm' };
  const cls = sizeMap[size] || sizeMap.md;

  if (!config) {
    return (
      <div className={`${cls} rounded-md bg-[#1A1A1A] flex items-center justify-center flex-shrink-0`} data-testid="provider-logo-generic">
        <CreditCard className="w-3.5 h-3.5 text-[#777]" />
      </div>
    );
  }

  return (
    <div
      className={`${cls} rounded-md flex items-center justify-center flex-shrink-0 font-black text-white`}
      style={{ backgroundColor: config.bg }}
      data-testid={`provider-logo-${resolved}`}
    >
      {config.letter}
    </div>
  );
}

export function PaymentProviderLabel({ provider, method }) {
  const resolved = provider || getProviderFromMethod(method);
  const config = PROVIDERS[resolved];
  return (
    <span className="font-semibold" style={config ? { color: config.color } : { color: '#EAE7E1' }}>
      {config ? config.label : (method || 'Payment')}
    </span>
  );
}

export const PROVIDER_LIST = [
  { id: 'venmo', label: 'Venmo', handleLabel: 'Venmo username', handlePlaceholder: '@yourname', urlTemplate: (h) => `https://venmo.com/${h.replace('@', '')}` },
  { id: 'cashapp', label: 'Cash App', handleLabel: 'Cash App handle', handlePlaceholder: '$yourname', urlTemplate: (h) => `https://cash.app/${h.startsWith('$') ? h : '$' + h}` },
  { id: 'paypal', label: 'PayPal', handleLabel: 'PayPal username', handlePlaceholder: 'yourname', urlTemplate: (h) => `https://paypal.me/${h}` },
  { id: 'zelle', label: 'Zelle', handleLabel: null, handlePlaceholder: null, urlTemplate: null },
  { id: 'custom', label: 'Other', handleLabel: null, handlePlaceholder: null, urlTemplate: null },
];
